import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { TDispatch } from '../..';
import { IAppState, IServiceProviderState } from '../../interfaces';
import { formatDateString } from '../../shared/utility';
import * as actions from '../../store/actions';
import { ETranslation } from '../../translations/translation-keys';
import Alert from '../UI/Alert/Alert';
import Spinner from '../UI/Spinner/Spinner';
import Table from '../UI/Table/Table';
import TableTh from '../UI/Table/TableTh/TableTh';
import { useTableSort } from '../UI/Table/useTableSort';

interface IProps {
  // valmiiksi tehty operator id:llä haku jos pitää adminien saada etsittyä
  operatorId?: string;
  onClick: (event: React.MouseEvent<HTMLTableRowElement>, id: string) => void;
}

const ServiceProviderForms: React.FC<IProps> = ({ operatorId, onClick }) => {
  const dispatch = useDispatch<TDispatch>();
  const { t } = useTranslation();

  const { loadingForm, errorForm, serviceProviderForms } = useSelector<IAppState, IServiceProviderState>(state => state.serviceProvider);
  const { sort, onSort, items: sortedForms } = useTableSort({ data: serviceProviderForms, defaultSort: { key: 'created', reverse: true, type: 'date' } });

  useEffect(() => {
    dispatch(actions.listServiceProviderForms(operatorId));
  }, [dispatch, operatorId]);

  return (
    <div>
      {errorForm && <Alert>{errorForm}</Alert>}
      <h2>{t(ETranslation.SERVICEPROVIDER_FORMS)}</h2>
      {loadingForm ? <Spinner />
        : serviceProviderForms && sortedForms
          ? (
            <Table hover sortContext={{ sort, onSort }}>
              <thead>
                <tr>
                  <TableTh sort="created" type="date">{t(ETranslation.COMMON_CREATED)}</TableTh>
                  <TableTh sort="company">{t(ETranslation.SERVICEPROVIDER_COMPANY)}</TableTh>
                  <TableTh sort="firstName">{t(ETranslation.SERVICEPROVIDER_FIRSTNAME)}</TableTh>
                  <TableTh sort="lastName">{t(ETranslation.SERVICEPROVIDER_LASTNAME)}</TableTh>
                  <th>{t(ETranslation.SERVICES)}</th>
                </tr>
              </thead>
              <tbody>
                {sortedForms.map(serviceProvider => (
                  <tr key={serviceProvider.id} onClick={(e) => onClick(e, serviceProvider.id)}>
                    <td>{serviceProvider.created && formatDateString(serviceProvider.created)}</td>
                    <td>{serviceProvider.company}</td>
                    <td>{serviceProvider.firstName}</td>
                    <td>{serviceProvider.lastName}</td>
                    <td>{serviceProvider.services?.map(s => s.name).join(", ")}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )
          : t(ETranslation.NO_SERVICEPROVIDER_FORMS)}
    </div>
  );
};

export default ServiceProviderForms;
